import { gql } from '@apollo/client';

export const FILTER_COLLECTION = gql`
  query Collection($key: String!, $isSignupQuery: Boolean, $scope: String! ) {
    collection(key: $key, isSignupQuery: $isSignupQuery, scope: $scope )
  }
`;
